(() => {
  const root = document.documentElement;
  const header = document.querySelector('[data-v3-header]');
  root.dataset.cachorrosRelease = 'CACHORROS-BOHO-EDITORIAL-V82';

  if (header) {
    const groups = [...header.querySelectorAll('.v3-nav details')];
    const search = header.querySelector('.v3-search');
    const navLinks = [...header.querySelectorAll('.v3-nav a[href]')];
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

    groups.forEach((group) => {
      const summary = group.querySelector(':scope > summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', String(group.open));
      group.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(group.open));
      });
    });

    navLinks.forEach((link) => {
      const path = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
      if (path === currentPath) link.setAttribute('aria-current', 'page');
    });

    search?.addEventListener('toggle', () => {
      if (!search.open) return;
      groups.forEach((group) => { group.open = false; });
      window.requestAnimationFrame(() => search.querySelector('input[type="search"]')?.focus({ preventScroll: true }));
    });

    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open && search?.open) search.open = false;
      });
    });
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const syncMotionPreference = () => {
    document.querySelectorAll('[data-cc4-video] video').forEach((video) => {
      if (reduceMotion.matches) video.pause();
    });
  };
  reduceMotion.addEventListener?.('change', syncMotionPreference);
  document.querySelectorAll('[data-cc4-video] video').forEach((video) => {
    video.addEventListener('loadeddata', syncMotionPreference);
  });
  document.addEventListener('visibilitychange', syncMotionPreference);
  syncMotionPreference();

  const scrollProductRail = (carousel, direction) => {
    const rail = carousel.querySelector('[data-cc-carousel-scroller]');
    const card = rail?.querySelector('[role="listitem"]');
    if (!rail || !card) return;
    const gap = parseFloat(getComputedStyle(rail).gap) || 14;
    rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  };

  const initProductCarousel = (carousel) => {
    if (carousel.dataset.ccV81Ready === 'true') return;
    carousel.dataset.ccV81Ready = 'true';
    const rail = carousel.querySelector('[data-cc-carousel-scroller]');
    const previous = carousel.querySelector('[data-cc-carousel-prev]');
    const next = carousel.querySelector('[data-cc-carousel-next]');
    previous?.addEventListener('click', () => scrollProductRail(carousel, -1));
    next?.addEventListener('click', () => scrollProductRail(carousel, 1));
    if (!rail) return;

    let syncFrame = 0;
    const syncControls = () => {
      const overflows = rail.scrollWidth > rail.clientWidth + 2;
      const atStart = rail.scrollLeft <= 2;
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      if (previous) {
        previous.disabled = !overflows || atStart;
        previous.setAttribute('aria-disabled', String(!overflows || atStart));
      }
      if (next) {
        next.disabled = !overflows || atEnd;
        next.setAttribute('aria-disabled', String(!overflows || atEnd));
      }
    };

    const scheduleControlSync = () => {
      window.cancelAnimationFrame(syncFrame);
      syncFrame = window.requestAnimationFrame(syncControls);
    };

    rail.setAttribute('tabindex', '0');
    rail.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      scrollProductRail(carousel, event.key === 'ArrowRight' ? 1 : -1);
    });
    rail.addEventListener('scroll', scheduleControlSync, { passive: true });
    window.addEventListener('resize', scheduleControlSync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(scheduleControlSync).observe(rail);
    scheduleControlSync();
  };

  const initProductCarousels = (scope = document) => {
    scope.querySelectorAll('[data-cc-product-carousel]').forEach(initProductCarousel);
  };

  const productCardSelector = '[data-cc-product-card-link]';
  const productCardInteractiveSelector = 'a, button, input, select, textarea, summary, label, [role="button"]';
  let pressedProductCard = null;
  let productCardPressX = 0;
  let productCardPressY = 0;
  let productCardPressMoved = false;

  document.addEventListener('pointerdown', (event) => {
    const card = event.target.closest(productCardSelector);
    if (!card) return;
    pressedProductCard = card;
    productCardPressX = event.clientX;
    productCardPressY = event.clientY;
    productCardPressMoved = false;
  }, { passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!pressedProductCard || productCardPressMoved) return;
    const horizontalDistance = Math.abs(event.clientX - productCardPressX);
    const verticalDistance = Math.abs(event.clientY - productCardPressY);
    productCardPressMoved = horizontalDistance > 8 || verticalDistance > 8;
  }, { passive: true });

  document.addEventListener('pointercancel', () => {
    pressedProductCard = null;
    productCardPressMoved = false;
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const card = event.target.closest(productCardSelector);
    const wasDragged = card && card === pressedProductCard && productCardPressMoved;
    pressedProductCard = null;
    productCardPressMoved = false;

    if (!card || wasDragged || event.defaultPrevented || event.button !== 0) return;
    if (event.target.closest(productCardInteractiveSelector)) return;

    const productUrl = card.dataset.ccProductCardLink;
    if (!productUrl) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(productUrl, '_blank', 'noopener');
      return;
    }
    window.location.assign(productUrl);
  });

  initProductCarousels();
  document.addEventListener('shopify:section:load', (event) => initProductCarousels(event.target));
})();
